import { render, staticRenderFns } from "./AnxLanguageSwitcher.vue?vue&type=template&id=7657fe93&scoped=true&"
import script from "./AnxLanguageSwitcher.vue?vue&type=script&lang=ts&"
export * from "./AnxLanguageSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./AnxLanguageSwitcher.vue?vue&type=style&index=0&id=7657fe93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7657fe93",
  null
  
)

export default component.exports